import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/shared/hooks/queries/queryKeys'
import { getPharmacies } from '@/features/auth/apis/pharmacy'
import { PharmacyListResponse } from '@/features/auth/types/pharmacy'

interface UsePharmacyListQueryReturn {
  pharmacyData: PharmacyListResponse | null
  isLoading: boolean
  error: Error | null
  refetch: () => void
}

/**
 * 薬局一覧取得クエリ（TanStack Query）
 *
 * 責務:
 * - 薬局一覧の取得
 * - キャッシュ管理（5分）
 *
 * 使用例:
 * ```tsx
 * const { pharmacyData, isLoading, error } = usePharmacyListQuery()
 * ```
 */
export const usePharmacyListQuery = (): UsePharmacyListQueryReturn => {
  const query = useQuery({
    queryKey: queryKeys.pharmacy.list(),
    queryFn: async (): Promise<PharmacyListResponse> => {
      const data = await getPharmacies()
      return data
    },
    staleTime: 1000 * 60 * 5, // 5分キャッシュ
  })

  return {
    pharmacyData: query.data ?? null,
    isLoading: query.isLoading,
    error: query.error ?? null,
    refetch: () => query.refetch(),
  }
}
